<div class="d-flex justify-content-end">
  @if (!getConfirmation && !isDeleting) {
    <div class="d-flex flex-wrap justify-content-end">
      @if (!isLookup) {
        @if (showHistoryButton) {
          <button
            type="button"
            class="btn btn-link px-3"
            (click)="showHistory(searchResult.id!)"
            [attr.data-test]="'history-btn-search-' + rowIndex"
            ngbTooltip="History"
            i18n-ngbTooltip="@@upp.global.button.search.history"
            triggers="hover"
            container="body"
          >
            <span class="fa-light fa-history"></span>
          </button>
        }
        <button
          type="button"
          class="btn btn-link px-3"
          (click)="showDetails(searchResult.id)"
          [attr.data-test]="'show-btn-search-' + rowIndex"
          ngbTooltip="Display"
          i18n-ngbTooltip="@@upp.global.button.display"
          container="body"
        >
          <span class="fa fa-file-lines"></span>
        </button>
        <button
          i18n="@@upp.global.button.modify"
          type="button"
          class="btn btn-link px-3"
          (click)="modifyDetails(searchResult.id)"
          [attr.data-test]="'modify-btn-search-' + rowIndex"
          ngbTooltip="Modify"
          i18n-ngbTooltip="@@upp.global.button.modify"
          container="body"
        >
          <span class="fa fa-pen-to-square"></span>
        </button>
        @if (!copyForbidden) {
          <button
            i18n="@@upp.global.button.copy"
            type="button"
            class="btn btn-link px-3"
            (click)="askForConfirmation(TYPE_COPY)"
            ngbTooltip="Copy"
            i18n-ngbTooltip="@@upp.global.button.copy"
            container="body"
          >
            <span class="fa fa-copy"></span>
          </button>
        }
        <button
          i18n="@@upp.global.button.search.delete"
          type="button"
          class="btn btn-link px-3"
          (click)="askForConfirmation(TYPE_DELETE)"
          [attr.data-test]="'delete-btn-search-' + rowIndex"
          ngbTooltip="Delete"
          i18n-ngbTooltip="@@upp.global.button.search.delete"
          container="body"
        >
          <span class="fa fa-trash-can text-danger"></span>
        </button>
      }
    </div>
  } @else if (!isDeleting) {
    <ngb-alert insert-alert-icon [dismissible]="false" type="warning" class="mt-3">
      <div class="d-flex flex-wrap confirmation-content">
        <span data-test="confirmation-message">{{ getConfirmationMessage() }}</span>
        @if (rowName) {
          <span class="ms-2">
            <strong>{{ rowName }}</strong>
          </span>
        }
        ?
      </div>
      <div class="me-4">
        <button
          i18n="@@upp.global.button.goBack"
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0 me-2"
          (click)="goBackConfirmation()"
          data-test="go-back-btn"
        >
          Go back
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2 mb-md-0"
          (click)="executeActionAfterConfirmation()"
          data-test="delete-confirmation-btn"
        >
          {{ getConfirmationActionMessage() }}
        </button>
      </div>
    </ngb-alert>
  } @else {
    <ama-loading-alert [sendingStatus]="isDeleting" message="Loading..." i18n-message="@@upp.global.messages.loading">
    </ama-loading-alert>
  }
</div>
